module.exports = __webpack_public_path__ + "img/sunrise_preview.57165252.webp";